import { EMAIL_REGEX } from "@/lib/constants";
import * as Yup from "yup";

const SignupSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("First name is required")
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name cannot exceed 50 characters"),

  last_name: Yup.string()
    .required("Last name is required")
    .min(2, "Last name must be at least 2 characters")
    .max(50, "Last name cannot exceed 50 characters"),

  email: Yup.string()
    .email("Invalid email address")
    .matches(
      EMAIL_REGEX,
      "Email must end with a valid TLD (e.g., .com, .org, .net, .io)",
    )
    .required("Email is required"),

  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and no spaces"
  
  
  
    ),
});

export default SignupSchema;
